import MasterLayout from './containers/MasterLayout'

export default MasterLayout